import AppLogo from '@/components/ui/AppLogo';

export default function Footer() {
  return (
    <footer className="border-t border-fg/5 py-10 px-6">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
        {/* Logo + links */}
        <div className="flex items-center gap-8">
          <AppLogo
            src="/assets/images/IMG-20260218-WA0010-1771430982362.jpg"
            size={36}
            className="rounded-sm opacity-80"
          />
          <div className="flex items-center gap-6 text-[13px] font-medium text-fg/40">
            <a href="#mercado" className="hover:text-fg/80 transition-colors">Mercado</a>
            <a href="#estrategias" className="hover:text-fg/80 transition-colors">Estratégias</a>
            <a href="#curitiba" className="hover:text-fg/80 transition-colors">Curitiba</a>
            <a href="#contato" className="hover:text-fg/80 transition-colors">Contato</a>
          </div>
        </div>

        {/* Legal */}
        <div className="flex items-center gap-6 text-[12px] text-fg/30">
          <span>© 2026 VS Cardoso Studios</span>
          <a href="#" className="hover:text-fg/60 transition-colors">Privacidade</a>
          <a href="#" className="hover:text-fg/60 transition-colors">Termos</a>
        </div>
      </div>
    </footer>
  );
}